import { jsx as _jsx } from "react/jsx-runtime";
import { Avatar, Tooltip } from "@mui/material";
import { TeamColorsCircle } from "./TeamColors";
export const TeamAvatar = ({ team, size = 56, showTooltip = true, }) => {
    const avatar = team.logo ? (_jsx(Avatar, { alt: team.name, src: team.logo, sx: { width: size, height: size } })) : (_jsx(Avatar, { sx: {
            width: size,
            height: size,
            bgcolor: "transparent",
            overflow: "hidden",
            p: 0,
        }, children: _jsx(TeamColorsCircle, { color1: team.primaryColour || "#6c757d", color2: team.secondaryColour || team.primaryColour || "#6c757d" }) }));
    if (showTooltip) {
        return (_jsx(Tooltip, { title: team.name, arrow: true, children: avatar }));
    }
    return avatar;
};
